import { render, staticRenderFns } from "./RichResultsRenderer.vue?vue&type=template&id=317d9ce8&scoped=true&"
import script from "./RichResultsRenderer.vue?vue&type=script&lang=js&"
export * from "./RichResultsRenderer.vue?vue&type=script&lang=js&"
import style0 from "./RichResultsRenderer.vue?vue&type=style&index=0&id=317d9ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317d9ce8",
  null
  
)

/* custom blocks */
import block0 from "./RichResultsRenderer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports